import { render, staticRenderFns } from "./Variable.vue?vue&type=template&id=6c2246dc&"
import script from "./Variable.vue?vue&type=script&lang=js&"
export * from "./Variable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports